import { lighten, SxProps } from '@mui/material';

import { CALENDAR_GRID_DEFAULTS } from './constants';

export const getCalendarGridColors = (color: string = CALENDAR_GRID_DEFAULTS.gridColor) => {
  return {
    textColor: color,
    gridColor: lighten(color, 0.77),
    tintColor: lighten(color, 0.95),
  };
};

export const normaliseSx = (sx?: SxProps) => (Array.isArray(sx) ? sx : sx ? [sx] : []);
